import { useCallback, useEffect, useSyncExternalStore } from 'react';
import { clipVersionStore } from '@/stores/clipVersionStore';
import { editorRestrictionsStore, EDITOR_RESTRICTION_REASONS } from '@/stores/editorRestrictionsStore';
import { ClipVersion } from '@/Pages/Clip/ClipPlayer/ClipCustomizer/ClipCustomizerVersioningPanel/types';

const VERSION_VIEW_BLOCKED_CAPABILITIES = [
  'clip-publish',
  'clip-download',
  'clip-create',
  'clip-undo-redo',
  'audio-mixer',
  'clip-save-template',
  'timeline-trim',
  'timeline-cut',
  'timeline-segment-dnd',
  'timeline-scene-edit',
  'timeline-scene-add',
  'timeline-transition-edit',
  'timeline-hook-add',
  'timeline-intro-outro-edit',
  'timeline-chapters-edit',
  'timeline-track-delete',
  'element-dnd',
  'element-popover',
  'element-zoom-effect',
  'element-customizer',
  'customizer-templates',
  'customizer-layout',
  'customizer-captions',
  'customizer-background',
  'customizer-images',
  'customizer-videos',
  'customizer-overlays',
  'customizer-audio',
  'transcript-edit',
  'transcript-download'
] as const;

export default function useClipVersions() {
  const { versions, viewingVersion } = useSyncExternalStore(clipVersionStore.subscribe, clipVersionStore.getSnapshot);

  const viewingVersionIndex = viewingVersion?.version_index ?? null;

  const currentVersionIndex = versions.length > 0 ? Math.max(...versions.map(v => v.version_index)) : 0;

  useEffect(() => {
    clipVersionStore.setVersions([]);
    return () => {
      clipVersionStore.setVersions([]);
    };
  }, []);

  const handleView = useCallback((version: ClipVersion) => {
    clipVersionStore.setViewingVersion(version);
    editorRestrictionsStore.setRestrictions(EDITOR_RESTRICTION_REASONS.VERSION_VIEW, [
      ...VERSION_VIEW_BLOCKED_CAPABILITIES
    ]);
  }, []);

  const handleRestore = useCallback((_version: ClipVersion) => {}, []);

  const exitViewMode = useCallback(() => {
    clipVersionStore.setViewingVersion(null);
    editorRestrictionsStore.clearRestrictions(EDITOR_RESTRICTION_REASONS.VERSION_VIEW);
  }, []);

  return {
    versions,
    viewingVersionIndex,
    viewingVersion,
    currentVersionIndex,
    handleView,
    handleRestore,
    exitViewMode
  };
}
